import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/source-serif-4/500.css';
import '@fontsource/source-serif-4/600.css';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Element #root ne obstaja.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
